module.exports = __webpack_public_path__ + "img/promo-card2.0ada7df9.png";